import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { NotificationsService, SimpleNotificationsComponent } from 'angular2-notifications';
import { Title } from './model/title';
import { TitleService } from './title.service';
import { EventlogService } from './eventlog.service';
import { Eventlog } from './model/eventlog';
import { UserService } from '../user/user.service';
import { User } from '../user/user';
import { DPCustomerService } from '../portalv1/dp-customer.service';
import { DPCustomer } from '../portalv1/dp-customer';
import { TitleRequest } from './model/titleRequest';
import { TitleRequestService } from './titleRequest.service';
import { DPAccount } from '../portalv1/dp-account';
import { DPAccountService } from '../portalv1/dp-accounts.service';

@Component({

    templateUrl: 'tms-landingpage.component.html'
})

export class TmsLandingpageComponent implements OnInit {
    titles: Title[];
    searchResults: Title[];
    errorResponse: any;
    notificationTitle: any;
    notificationContent: any;
    notificationType: any;
    deleting = false;
    viewSearchResult = false;
    latestTitles: Title[];
    latestNotes: Eventlog[];
    users: User[];
    authors: String[];
    customerList: DPCustomer[];
    allNotes: Eventlog[];
    allTitleRequestList: TitleRequest[];
    requestsByCustomer: TitleRequest[];
    titlesForCustomer: Title[];
    accountList: DPAccount[];
    filteredTitles: Title[];
    titlesByAccount: Title[];
    validationStates: Number[];



    constructor(
        private router: Router,
        private _service: NotificationsService,
        private titleService: TitleService,
        private eventlogService: EventlogService,
        private route: ActivatedRoute,
        private userService: UserService,
        private customerService: DPCustomerService,
        private accountService: DPAccountService,
        private titleRequestService: TitleRequestService) {
    }

    ngOnInit() {
        this.getTitles();
        this.getCustomers();
        this.getAllUsers();
        this.searchResults = new Array<Title>();
    }
    /**Get a list of all customers */
    getCustomers() {
        this.customerService.getCustomers()
            .then(res => {
                this.customerList = res.customers;
            })
            .catch(error => this.errorHandler(error));
    }
    /**
     * filter the list of latest activity by customer
     */
    filterActivityByCustomer(customer_id: number) {
        this.accountList = null;
        if (customer_id != null && customer_id != (-1)) {
            this.getAccountsByCustomer(customer_id);
            if (this.allTitleRequestList == null) {
                this.titleRequestService.getAllRequests()
                    .then(res => this.allTitleRequestList = res.pcRequests)
                    .then(res => this.filterActivity())
                    .catch(error => this.errorHandler(error));
            }
        }
        else {
            this.filteredTitles = this.titles;
        }
    }
    /**
     * get the name of the given user
     */
    getAuthorName(user_id: number) {

        const user = this.users.find(user => user.user_id == user_id);
        return user.first_name + ' ' + user.last_name;
    }
    /**
     * filter the list of latest activity by account
     */
    filterActivityByAccount(accountId: number) {
        if (accountId == null || accountId == -1) {
            this.filterActivity();
        }
        else {
            this.requestsByCustomer = this.allTitleRequestList.filter(req => req.account_id == accountId);
            this.latestNotes = this.allNotes.filter(note => this.isNoteForReqTitle(note));
            this.latestNotes.forEach(note => note.titleObject = this.titles.filter(title => title.content_id == note.content_id)[0]);
        }
    }
    /**
     * Filter titles based on chosen account
     */
    filterActivity() {
        if (this.allTitleRequestList != null && this.accountList != null) {
            this.requestsByCustomer = this.allTitleRequestList.filter(req => this.isRequestByCust(req));
            this.filteredTitles = this.titles.filter(title => this.isTitleRequestedByCust(title));
            this.latestNotes.forEach(note => note.titleObject = this.titles.filter(title => title.content_id == note.content_id)[0]);
        }
    }
    /**
     *
     */
    isTitleRequestedByCust(title: Title) {
        for (const req of this.requestsByCustomer) {
            if (title.content_id == req.content_id) {
                return true;
            }
        }
    }
    /**
     * function to filter req by accounts for selected customer
     */
    isRequestByCust(req: TitleRequest) {
        for (const account of this.accountList) {
            if (account.account_id == req.account_id) {
                return true;
            }
        }
    }
    /**
     * function to filter request based on request by customer
     */
    isNoteForReqTitle(note: Eventlog) {
        for (const req of this.requestsByCustomer) {
            if (note.content_id == req.content_id) {
                return true;
            }
        }
    }
    /**
     * Navigates to the create title page
     */
    goToCreateTitle() {
        this.router.navigateByUrl('/tms/createTitle');
    }
    /**
     * Gets a list of pending titles
     */
    getTitles() {
        return this.titleService
            .getTitles()
            .then(res => {
                this.setTitles(res.titles);
            })
            .catch(error => this.errorHandler(error));
    }
    /**
     * Gets the full list of notes for all titles
     */
    getAllEventlog() {
        return this.eventlogService
            .getAllNotes()
            .then(res => {
                this.setTitleToNotes(res.logs);
            })
            .catch(error => this.errorHandler(error));
    }
    /**
     * Orders the list of notes desc by date and sets the top 15 to be displayed on the page
     */
    setTitleToNotes(notes: Eventlog[]) {
        this.allNotes = notes;
        this.allNotes = notes.sort((a: Eventlog, b: Eventlog) => {
            if (a.entry_date > b.entry_date) {
                return -1;
            } else if (a.entry_date == b.entry_date) {
                return 0;
            } else {
                return 1;
            }
        });
        this.allNotes.forEach(note => note.titleObject = this.titles.filter(title => title.content_id == note.content_id)[0]);
        this.latestNotes = this.allNotes.slice(0, 50);

    }

    /**
     * Orders the titles by added date, then filters them to display the live titles
     */
    setTitles(titles: Title[]) {
        this.titles = titles;
        this.filteredTitles = titles;
        this.getAllEventlog();

        this.latestTitles = titles.sort((a: Title, b: Title) => {
            if (a.added_date > b.added_date) {
                return -1;
            } else if (a.added_date == b.added_date) {
                return 0;
            } else {
                return 1;
            }
        });
        this.latestTitles = this.latestTitles.filter(title => title.catalog_state == 3);
    }

    /**
     * Gets all internal users for the ops portal
     */
    getAllUsers() {
        this.userService.getUsers()
            .then(res => this.users = res.user)
            .catch(error => this.errorHandler(error));
    }
    /**
     * filters titles list when search term is being typed
     */
    filterTitle(term: string) {
        if (term !== '') {
            this.searchResults = this.titles.filter(u => (u.title.toLowerCase().includes(term.toLowerCase()) ||
                u.content_id.toLowerCase().includes(term.toLowerCase())));
            this.viewSearchResult = true;
        }
    }
    /**
     * navigates to the details page for the selected title
     */
    goToDetails(title: Title) {
        this.router.navigate(['/tms/titleDetails', title.content_id]);
    }
    errorHandler(error: any) {
        this.notificationType = 'error';
        this.notificationTitle = 'Error';
        const jsonErrorBody = JSON.parse(error._body);
        this.notificationContent = jsonErrorBody.error.message;
        this.createNotification();
        this.deleting = false;

    }

    createNotification() {
        switch (this.notificationType) {
            case 'success':
                this._service.success(this.notificationTitle, this.notificationContent);
                break;
            case 'error':
                this._service.error(this.notificationTitle, this.notificationContent);
                break;
            case 'info':
                this._service.info(this.notificationTitle, this.notificationContent);
                break;
        }
    }

    closeSearchResult() {
        this.viewSearchResult = false;
    }

    handleBlur() {
        setTimeout(() => {
            this.searchResults = [];
        }, 200);
    }
    /**
     * Gets a list of accounts for the given customer
     */
    getAccountsByCustomer(customer_id: number) {
        this.accountService.getAccountsByCompanyId(customer_id)
            .then(res => {
                this.accountList = res.user_accounts;
            })
            .then(res => this.filterActivity())
            .catch(error => this.errorHandler(error));
    }
}



// WEBPACK FOOTER //
// ./src/app/tms/tms-landingpage.component.ts